import styled, { css } from 'styled-components';

export const TableRowRoot = styled.tr`
	color: inherit;
	display: table-row;
	position: relative;
	vertical-align: middle;
	&:hover {
			background-color: rgba(0, 0, 0, 0.2);
	}
	${(props) => props.disabled && css`
			position: relative;
			&:after {
				content: '';
				top: 0;
				left: 0;
				position: absolute;
				height: 100%;
				width: 100%;
				z-index: 1;
				background: #fff;
				opacity: 0.6;
				cursor: not-allowed;
			}
		`}
`;
